import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import TitleSection from '../../components/layout/TitleSection';
import { StatGroup } from '../../components/stats/StatGroup';
import ActualityAggregatedStatsTotal from '../components/ActualityAggregatedStatsTotal';
import FeedAggregatedPieChart from '../components/FeedAggregatedPieChart';
import { actualityAggregatedStatsTotal } from '../store/actuality.kpi.state';

type ActualityAggregatedStatsSummarySectionProps = {};

const ActualityAggregatedStatsSummarySection: React.FC<
  ActualityAggregatedStatsSummarySectionProps
> = props => {
  const { t } = useTranslation('feed');
  const totalStats = useRecoilValue(actualityAggregatedStatsTotal);
  return (
    <StatGroup>
      <div className={classNames('flex flex-1 flex-col')}>
        <FeedAggregatedPieChart
          defaultAggregateBy="eventProcessType"
          showAggregationControl={true}
          title={t`Activity Analysis`}
        />

        <TitleSection
          title={t`Warehouse Scorecard`}
          inPanelView
          className="!mt-4"
          isTransparent
        >
          <ActualityAggregatedStatsTotal data={totalStats} />
        </TitleSection>
      </div>
    </StatGroup>
  );
};

export default ActualityAggregatedStatsSummarySection;
